import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SignupApp } from './App';
import { readSignupOffersFromEnv } from './config/signupOffers';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('FAIL: #root element missing from index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <SignupApp offers={readSignupOffersFromEnv()} />
  </StrictMode>
);
